import { clock, type PlanStop } from "../../api/routing";

function lateness(minutes: number | null): string {
  if (minutes === null) {
    return "";
  }
  if (minutes > 0) {
    return ` (${minutes} min late)`;
  }
  if (minutes < 0) {
    return ` (${-minutes} min early)`;
  }
  return " (on time)";
}

/** "Planned 08:35-10:05 · Actual 08:52-10:30 (17 min late)": what the plan said
 * beside what the crew recorded, or that nothing was recorded. */
export default function StopActual({ stop }: { stop: PlanStop }) {
  const planned = `Planned ${clock(stop.arrive_min)}-${clock(stop.depart_min)}`;
  const actual = stop.actual ?? null;
  if (actual === null || actual.arrive_clock === null) {
    return <span className="plan-stop-actual">{`${planned} · Actual: not recorded`}</span>;
  }
  return (
    <span className="plan-stop-actual">{`${planned} · Actual ${actual.arrive_clock}-${actual.depart_clock ?? "…"}${lateness(actual.late_minutes)}`}</span>
  );
}
